import { render, staticRenderFns } from "./ks-join-us.vue?vue&type=template&id=09f46a58"
var script = {}
import style0 from "./ks-join-us.vue?vue&type=style&index=0&id=09f46a58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports